import 'babel-polyfill';
import 'isomorphic-unfetch'; // Needed to provide Fetch to IE11
import 'array-flat-polyfill'; // Flatmap support for legacy Edge
import React from 'react';
import {Helmet} from "react-helmet";
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-slidedown/lib/slidedown.css'
import 'react-tabs/style/react-tabs.css';
import {render} from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import 'van11y-accessible-accordion-aria/dist/van11y-accessible-accordion-aria.min';
import {ApolloProvider} from 'react-apollo';
import {CookiesProvider} from 'react-cookie';
import {Provider as AlertProvider, transitions as alertTransitions} from 'react-alert';
import smoothscroll from 'smoothscroll-polyfill';
import Modal from 'react-modal';
import AlertTemplate from './components/alert/alertTemplate';
import {createStore} from './helpers/react-hookstore';
import {fetchCookies} from './helpers/cookies';
import App from './App';
import ScrollTop from "./ScrollTop";
import {getApolloClient} from "./helpers/apollo";

// Smoothscroll Polyfill for Safari
smoothscroll.polyfill();

// Create Cookie Object to allow Apollo to access data
const cookies = fetchCookies();

// GraphQL Client with optional Authorization
const authToken = (window.lin && window.lin.at) ? window.lin.at : '';
const tokenForRefresh = cookies.get('x-auth-refresh-token') || '';
const authContext = cookies.get('x-context');

// Default API Host
const defaultClient = getApolloClient(authToken, tokenForRefresh, cookies, authContext);

// Reset floatingDLs
window.floatingDLs = [];

// Load global React Hook Store
createStore('loadedComponentStore', {});

const alertConfig = {
    position: 'bottom center',
    timeout: 10000,
    offset: '30px',
    transition: alertTransitions.SCALE,
    zindex: 10000 // Required to position above cookieConsent
};

// Bind modal to root app element (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#app');

const renderApp = (apolloClient) => {
    render(
        <CookiesProvider cookies={cookies}>
            <BrowserRouter>
                <ScrollTop>
                    <AlertProvider template={AlertTemplate} {...alertConfig}>
                        <ApolloProvider client={apolloClient}>
                            <Helmet>
                                <meta charSet="utf-8" />
                                <title>The Leader in e-Trading for Global Fixed Income | MarketAxess</title>
                                <meta name="description" content="MarketAxess is the leading fixed income electronic trading platform for institutional investors and dealers. Access the global credit network today." />
                                <meta name="keywords" content="marketaxess, fixed income, electronic trading, trading, platform, trading platform, institutional investors, dealers, network, credit, credit trading" />
                                <meta name="viewport" content="width=device-width, initial-scale=1" />
                            </Helmet>
                            <App />
                        </ApolloProvider>
                    </AlertProvider>
                </ScrollTop>
            </BrowserRouter>
        </CookiesProvider>,
        document.getElementById('app')
    )
};


renderApp(defaultClient);

    // Hot Reloading for Development
    if (module.hot) {
        module.hot.accept('./App', () => {
            renderApp(defaultClient);
        });
    }




// WEBPACK FOOTER //
// ./frontend/ClientApp.jsx